import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { DayjsDateAdapter, DAYJS_DATE_FORMATS } from '../dayjs-date-adapter';

import { Fecha } from './fecha.component';
import { FechaDirective } from './fecha.directive';

@NgModule({
	declarations: [
		Fecha,
		FechaDirective,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatFormFieldModule,
		MatInputModule,
		MatIconModule,
		MatButtonModule
	], providers: [
		{ provide: MAT_DATE_LOCALE, useValue: 'es' },
		{ provide: DateAdapter, useClass: DayjsDateAdapter, deps: [MAT_DATE_LOCALE] },
		{ provide: MAT_DATE_FORMATS, useValue: DAYJS_DATE_FORMATS },
	], exports: [
		Fecha
	]
})
export class FechaModule { }
